"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var logLevel_1 = require("./logLevel");
var utils_1 = require("./utils");
var Logger = /** @class */ (function () {
    function Logger(settings, enabled) {
        this.settings = settings;
        this.enabled = enabled;
    }
    Logger.getInstance = function (settings, enabled) {
        if (!Logger.instance) {
            Logger.instance = new Logger(settings || Logger.DEFAULT_SETTINGS, enabled ? true : false);
        }
        return Logger.instance;
    };
    Logger.prototype.add = function (message, level) {
        if (this.enabled && (this.settings.level.code >= level.code)) {
            if (utils_1.default.isClient()) {
                console.log("%c[" + level.name + "] [" + new Date().toISOString() + "] - " + message, level.style);
            }
            else {
                console.log("[" + level.name + "] [" + new Date().toISOString() + "] - " + message);
            }
        }
    };
    Logger.DEFAULT_SETTINGS = {
        level: logLevel_1.default.DISABLED,
    };
    return Logger;
}());
exports.default = Logger;
//# sourceMappingURL=logger.js.map